<template>
  <el-dialog
    :visible.sync="loginVisible"
    :show-close="false"
    :close-on-click-modal='false'
    :close-on-press-escape='false'>
    <div class="login_box">
      <div class="login_right">
        <div class="tag"><i class="el-icon-close" @click="back"></i></div>
        <img class="shopvidi_logo" src="@/assets/img/shopvidi_logo.png" alt="">
        <el-form :model="loginForm" ref="loginForm" v-if="type ==='login'">
          <el-form-item
            prop="email"
            :rules="[
              {
                required: true,
                message: 'Please enter the email',
                trigger: 'blur',
              },
              {
                type: 'email',
                message: 'Please enter the correct email address or password',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input v-model="loginForm.email" placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item
            prop="password"
            :rules="{
              required: true,
              message: 'Please enter the correct email address or password',
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="loginForm.password"
              type="text"
              @focus="changeType"
              placeholder="Password"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="loginForm.remember">Remember</el-checkbox>
          </el-form-item>
          <el-form-item>
            <p class="text_agreen">By clicking Login, you agree to our <a href="https://www.shopvidi.com/term-service"><span class="organ_color" >Terms of Service</span></a></p>
          </el-form-item>
          <el-button
            :loading="loading"
            type="primary"
            @click="submitForm('loginForm')"
            class="btn"
            >Login
          </el-button>
          <div class="register" @click="changeForm('register')">Register</div>
        </el-form>

        <!-- 注册 -->
        <el-form style="width:90%" :model="registerForm" ref="registerForm" v-if="type ==='register'">
          <el-form-item
            prop="username"
            :rules="{
              required: true,
              validator: userNameCheck,
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="registerForm.firstName"
              placeholder="First Name"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()}"
            />
          </el-form-item>
          <el-form-item
            prop="username"
            :rules="{
              required: true,
              validator: userNameCheck2,
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="registerForm.lastName"
              placeholder="Last Name"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()}"
            />
          </el-form-item>
          <el-form-item
            prop="email"
            :rules="[
            {
              required: true,
              message: 'Please enter the email',
              trigger: 'blur'
            },
            { validator: checkEmail, trigger: 'blur' }
          ]"
          >
            <el-input
              v-model="registerForm.email"
              placeholder="Business Email"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()}"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="flex cust-form-item cust-form-item2"
            prop="countryCode"
            :rules="{
              validator: checkPhone,
              trigger: 'change',
            }"
          >
            <el-select
              v-model="codeObject"
              filterable
              placeholder="+ Country Code"
              @change="codeChange"
            >
              <el-option
                v-for="(item, index) in options"
                :label="item.text"
                :value="item"
                :key="index"
              >
                <span style="float: left">{{ item.text }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.value
                }}</span>
              </el-option>
            </el-select>
            <el-input
              v-model="registerForm.phone"
              placeholder="Phone"
              @input="changePhone"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="password"
            class="cust-form-item"
            :rules="{ validator: handlePasswordLevel, trigger: 'change' }"
          >
            <!-- <el-popover
              ref="popover"
              placement="top-start"
              width="200px"
              trigger="focus"
            >
              <div :style="'color:' + levelColor[levelStatus]">
                <i :class="levelClass[levelStatus]"></i>
                {{ levelNames[levelStatus] }}
              </div>
              <div style="display: flex;">
                <el-progress
                  style="width: 33%"
                  v-for="(item, id) in levelNames"
                  :key="id"
                  v-if="id > 0"
                  :percentage="
                    id > levelStatus ? 0 : id < levelStatus ? 100 : levelPercent
                  "
                  :show-text="false"
                  :color="levelColor[levelStatus]"
                ></el-progress>
              </div>
            </el-popover> -->
            <el-input
              :type="passw"
              @focus="changeType"
              v-model="registerForm.password"
              autocomplete="new-password"
              placeholder="Password"
            >
              <i slot="suffix" @click="showPass">
                <img
                  v-if="passw=='password'"
                  class="reg-show-hide-icon"
                  src="@/assets/img/icon-hide.png"
                  alt="" />
                <img
                  v-else
                  class="reg-show-hide-icon"
                  src="@/assets/img/icon-show.png"
                  alt="" />
              </i>
            </el-input>
          </el-form-item>
          <div class="text_agreen_register">By clicking Login, you agree to our <a href="https://www.shopvidi.com/term-service"><span class="organ_color" >Terms of Service</span></a></div>
          <el-button
              type="primary"
              :loading="loading"
              @click="submitForm('registerForm')"
              class="btn"
              >Next
          </el-button>
          <div class="text_agreen_register">Already have ShopVidi account?<span class="login-now" @click="changeForm('login')">Log in now</span></div>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Vue from 'vue'
import { postAction, getAction } from '@/api/manage.js'
export default {
  props: {
    loginVisible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'register'
    }
  },
  data() {
    return {
      levelNames: ['low', 'low', 'Medium', 'Strong'],
      levelClass: [
        'el-icon-error',
        'el-icon-error',
        'el-icon-warning',
        'el-icon-success'
      ],
      levelColor: ['#ff0000', '#ff0000', '#ff7e05', '#52c41a'],
      levelStatus: 0,
      levelPercent: 10,
      emailLimit: '',
      onlyFlagEmail: false,
      passw: 'password',
      loading: false,
      codeObject: '+1(US)',
      newCountryCode: '',
      options: JSON.parse(localStorage.getItem('allCountry')) || [],
      countryNameCode: '',
      loginForm: {
        email: '',
        password: ''
      },
      registerForm: {
        email: '',
        password: '',
        code: '',
        phone: '',
        countryCode: '+1(US)',
        firstName: '',
        lastName: ''
      }
    }
  },
  watch: {
    type: {
      handler(n, o) {
        this.type = n
      }
    }
  },
  created() {
    this.getPhoneAndCountry()
    this.loadConfigurationEmal()
  },
  methods: {
    changeForm(type) {
      this.$emit('changeForm', type)
    },
    /**
     * 密码强度校验
     */
    handlePasswordLevel(rule, value, callback) {
      let level = 0
      let reg =
        /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/
      if (value === '') {
        callback(new Error('Please enter the Password'))
      }
      if (!reg.test(value)) {
        callback(
          new Error(
            'The password contains at least 8 characters, a combination of letters, numbers and special characters'
          )
        )
      }
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.levelStatus = level
      this.levelPercent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.levelPercent = 100
        }
        callback()
      } else {
        if (level === 0) {
          this.levelPercent = 10
        }
        callback(new Error('The password strength is not enough'))
      }
    },
    /**
     * 变化type类型
     */
    showPass() {
      // 点击图标是密码隐藏或显示
      if (this.passw === 'text') {
        this.passw = 'password'
      } else {
        this.passw = 'text'
      }
    },
    /**
     * 手机号变化
     */
    changePhone(value) {
      this.registerForm.phone = value.replace(/[^\d]/g, '')
    },
    /**
     * 手机号国家变化
     */
    codeChange(code) {
      this.registerForm.countryCode = code.value
      this.codeObject = code.value
      if (code.desc) {
        let numberValue = code.desc.split(':')
        this.newCountryCode = numberValue[0]
      }
    },
    /**
     * 获取国家、手机号配置信息
     */
    getPhoneAndCountry() {
      getAction('/sys/dict/getDictItems/reg-country-config').then(response => {
        if (response.success) {
          if (response.result) {
            this.options = response.result
            localStorage.setItem('allCountry', JSON.stringify(response.result))
            console.log(JSON.parse(localStorage.getItem('allCountry')), '存到localStorage里的country')
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    /**
     * 检查邮件配置
     */
    loadConfigurationEmal() {
      getAction('/simple/configuration?key=sign_up_email_limit').then(response => {
        if (response.success) {
          if (response.result.configurationValue) {
            if (response.result.configurationValue !== '') {
              this.emailLimit = response.result.configurationValue
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    /**
     * 检查手机号
     */
    checkPhone(rule, value, callback) {
      let phone = this.registerForm.phone
      let code = this.registerForm.countryCode
      if (code === '') {
        callback(new Error('Please enter the countryCode'))
      }
      if (phone === '') {
        callback(new Error('Please enter the phone'))
      }
      // 如果是美国或者英国则判断后面手机号的长度
      if (code.indexOf('+1(US)') > -1 || code.indexOf('+44(UK)') > -1 || code.indexOf('+1(CA)') > -1) {
        if (phone.length !== 10) {
          callback(new Error('Please enter the correct number'))
        }
      }
      if (code.indexOf('+61(AU)') > -1) {
        if (phone.length !== 9) {
          callback(new Error('Please enter the correct number'))
        }
      }
      this.checkOnlyEmail(code + '-' + phone, 'phone')
      let that = this
      setTimeout(function () {
        if (that.onlyFlagPhone) {
          callback(new Error('This number has already been registered.'))
        } else {
          callback()
        }
      }, 300)
    },
    /**
     * 检查邮箱
     */
    checkEmail(rule, value, callback) {
      if (value) {
        value = value.trim()
      }
      var reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      //  先判断格式是否正确，格式不正确则直接返回
      if (reg.test(value)) {
        //  判断我们是否有邮箱验证，
        if (this.emailLimit !== '') {
          let index = value.indexOf('@')
          if (index > -1) {
            const emailSuffix = value.substring(index, value.length)
            if (this.emailLimit.indexOf(emailSuffix) > -1) {
              callback(new Error('Please enter your email, if you cannot register, please contact customer service'))
              return
            }
            callback()
          }
          callback(new Error('Please enter the correct email address'))
          return
        }
        this.checkOnlyEmail(value, 'email')
        let that = this
        setTimeout(function () {
          if (that.onlyFlagEmail) {
            callback(new Error('This email has already been registered.'))
          } else {
            callback()
          }
        }, 300)
      } else {
        callback(new Error('Please enter the correct email address'))
      }
    },
    async checkOnlyEmail(value, type) {
      const params = {}
      if (type === 'email') {
        params.email = value
      } else {
        params.phone = value
      }
      let res = await getAction('/sys/user/checkOnlyUser', params)
      if (type === 'email') {
        // true ：表示存在
        this.onlyFlagEmail = !res.success
      } else {
        this.onlyFlagPhone = !res.success
      }
    },
    /**
     * 检查FirstName
     */
    userNameCheck(rule, value, callback) {
      if (this.registerForm.firstName === '') {
        callback(new Error('Please enter the firstName'))
      }
      callback()
    },
    /**
     * 检查LastName
     */
    userNameCheck2(rule, value, callback) {
      if (this.registerForm.lastName === '') {
        callback(new Error('Please enter the lastName'))
      }
      callback()
    },
    changeType(e) {
      e.srcElement.type = 'password'
    },
    /**
     * 返回
     */
    back() {
      this.loginForm = {}
      this.registerForm = {}
      this.$emit('backVisible')
    },
    /**
     * 提交验证
     */
    submitForm(type) {
      this.$refs[type].validate(async (valid) => {
        if (valid) {
          if (this.loading) {
            return
          }
          this.loading = true
          if (type === 'loginForm') {
            this.loginHandle()
          } else {
            this.registerHandle()
          }
        }
      })
    },
    // 注册接口
    registerHandle() {
      let values = this.registerForm
      if (values.countryCode === '') {
        this.$message.warning('Please enter country code!')
        return
      }
      var register = {
        phone: values.countryCode + '-' + values.phone,
        firstName: values.firstName,
        lastName: values.lastName,
        password: values.password,
        email: values.email,
        verifyCode: values.code,
        userSource: 3,
        model: 3,
        isVidirect: 1,
        supplierManagementModel: 1,
        countryCode: this.registerForm.countryCode === '+1(US)' ? 'US' : this.newCountryCode
      }
      postAction('/sys/user/register', register).then((res) => {
        if (res.success) {
          this.loginForm = {
            ...register,
            ...{
              remember_me: true
            }
          }
          this.loginHandle()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    /**
     * 登录
     */
    async loginHandle() {
      let username = this.loginForm.email.trim()
      let res = await postAction('/sys/login', {
        password: this.loginForm.password,
        remember_me: this.loginForm.remember,
        username: username,
        loginEntry: 2
      })
      if (res.code === 200) {
        this.$ls.set('token', res.result.token)
        this.$ls.set('userInfo', res.result.userInfo)
        this.$ls.set('realname', res.result.userInfo.realname)
        Vue.prototype.login = true
        Vue.prototype.username = res.result.userInfo.firstName + res.result.userInfo.lastName
        // 登录成功后 获取当前用户的business 审核状态
        this.$router.push('/review')
        // this.loadSysRole()
      } else {
        this.$message.warning(res.message)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog{
  width: 95%;
}
/deep/ .el-input{
  height: 40px;
}
/deep/.el-button--primary{
 height: 50px;
 background: #262B2F;
 border: none;
 border-radius: 0;
 width: 100%;
}
/deep/.el-form-item__error{
  // margin-left: 40px;
}
.reg-show-hide-icon{
  width:16px;height:16px;
}
.text_agreen{
  width:100%;
  margin-top:-28px;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
}
.btn{
  margin-top: 5px;
}
.text_agreen_register{
  padding: 15px 0px;
  width:100%;
  font-size: 13px;
  font-family: Graphik;
  font-weight: 400;
  text-align: center;
  .login-now{
    margin-left: 10px;
    text-decoration: underline;
    font-family: Satoshi-Bold !important;
    font-weight: 400 !important;
  }
}
.organ_color{
  color: #FB541C;
  text-decoration:underline;
  cursor: pointer;
}
.login_box {
  width: 100%;
  background: rgba(255, 255, 255, 0.39);
  border: 1px solid #f0f0f0;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  .login_right{
    width: 98%;
    margin:0 auto;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tag{
      width: 95%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
    .shopvidi_logo{
      width: 175px;
      height: 45px;
      margin-bottom: 20px;
    }
  }

}
.register{
  width: 100%;
  text-align: center;
  margin: 28px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/register/register-dialog.vue